import React, { useState, useEffect } from 'react';
import { Image, RichText, Text, getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import GraphQLData from '../../lib/GraphQLData';
import { loader as gqlLoader } from 'graphql.macro';
import compose from 'compose-function';
import { withTranslation } from 'react-i18next';

const UnderstandLifeInsuranceQuery = gqlLoader('./UnderstandLifeInsurance.graphql');

const UnderstandLifeInsuranceInner = (props) => {
  const header = props?.data?.things_to;
  const contents = props?.data?.keep_in_mind_items?.children;

  const [isActive, setIsActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);
  const [selectedOptionText, setSelectedOptionText] = useState('');

  useEffect(() => {
    if (contents && contents.length > 0) {
      const firstItem = contents[0];
      if (firstItem?.menuTitle?.value) {
        setSelectedOptionText(firstItem.menuTitle.value);
      }
    }
  }, [contents]);

  const handleMenuClick = () => {
    setIsActive(!isActive);
  };

  const handleOptionClick = (index) => {
    setSelectedOption(index);
    setIsActive(false);

    const selectedOptionTextValue = contents[index]?.menuTitle?.value;
    setSelectedOptionText(selectedOptionTextValue);
  };

  const [activeQuestion, setActiveQuestion] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const handleQuestion = (questionNumber, quesNo) => {
    setSelectedQuestion(quesNo);
    setActiveQuestion(questionNumber);
  };

  const regex = /#item--i(\d+)/;

  
  useEffect(() => {
    const sections = document.querySelectorAll('.scroll-item-xx');
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            
            document.querySelectorAll('#list-example a').forEach((link) => {
              link.classList.remove('active');
            });

            
            const link = document.querySelector(`a[href="#${entry.target.id}"]`);
            link.classList.add('active');
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, [props]);

  return (
    <>
      <section
        className="understand-life-insurance span-1-anm"
        id={header?.stickyNavId?.value} 
        data-aos="fade-up"
        data-aos-duration={2000}
      >
        <div className="underlife-wrapper">
          <div className="section-heading-row">
            <div className="hear-what-the-expert-heading">
              <h2 className="section-heading heading-flex">
                <RichText tag="span" field={header?.heading} editable={true} />
              </h2>
            </div>
          </div>
          <div className="scrollspy-area">
            <div className="scrolling-wrapper">
              <div className="scrolling-flex">
                <div className="list-group Understanding-col1">
                  <div className="list-panel">
                    <div className="list-title">
                      <div className="scrollsy-title">
                        {props?.i18n?.store?.data?.en?.translation?.TableContents}
                      </div>
                    </div>
                    <div
                      className="list-panel-anchor deskTop---view--block list-group"
                      id="list-example"
                    >
                      {contents?.map((item, index) => {
                        const fragmentId = item.menuLink.url.split('#')[1];
                        const hrefAttribute = `#${fragmentId}`;
                        const isActive = index === 0; 
                        return (
                          <a
                            key={index}
                            className={`list-group-item list-group-item-action tableCOntent-heading ${isActive ? 'active' : ''
                              }`}
                            href={hrefAttribute}
                          >
                            <Text field={item?.menuTitle} editable={true} />
                          </a>
                        );
                      })}
                    </div>
                  </div>
                  <div className="input-group input---mb cal_custom_drop3 moBile---view--block">
                    <div className={`select-menu ${isActive ? 'active' : ''}`}>
                      <div className="select-btn" onClick={handleMenuClick}>
                        <span className="sBtn-text">{selectedOptionText}</span>
                      </div>
                      <ul className="options">
                        {contents?.map((question, index) => {
                          const fragmentId = question.menuLink.url;
                          const match = fragmentId.match(/#item--i(\d+)/);
                          const quesNo = match ? match[1] : null;
                          return (
                            <li
                              key={`option-x${index + 1}`}
                              className={`option ${index === selectedOption ? 'selected_option' : ''
                                }`}
                              onClick={() => {
                                handleOptionClick(index);
                                handleQuestion(`${index + 1}`, quesNo);
                              }}
                            >
                              <span className="option-text">
                                <Text field={question?.menuTitle} editable={true} />
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  data-bs-spy="scroll"
                  data-bs-smooth-scroll="true"
                  data-bs-target="#list-example"
                  data-bs-offset={0}
                  className="overflow-div scrollspy-example Understanding-col2"
                  tabIndex={0}
                >
                  {contents?.map((data, index) => {
                    var field = data?.data_[0]?.description;
                    const fragmentId = data?.menuLink?.url?.split('#')[1];
                    const match = data?.menuLink?.url?.match(regex);
                    const quesNo = match ? match[1] : null;
                    const isActive =
                      selectedQuestion === null ? quesNo === '1' : quesNo === selectedQuestion;
                    return (
                      <React.Fragment key={index}>
                        <RichText
                          key={quesNo}
                          field={field}
                          className={`scroll-item-xx ${isActive ? 'activemm' : ''}`}
                          id={fragmentId}
                        />
                        {index !== contents.length - 1 && <div className="dvdr" />}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default function UnderstandLifeInsurance(props) {
  const Wrapper = compose(
    withTranslation(),
    GraphQLData(UnderstandLifeInsuranceQuery, {
      name: 'data',
      options: {
        variables: {
          underStandingFolder: props?.fields?.UnderstandingFolder?.id
            ? props?.fields?.UnderstandingFolder?.id
            : '',
          datasource: props?.rendering?.dataSource ? props?.rendering?.dataSource : '',
        },
      },
    })
  )(UnderstandLifeInsuranceInner);
  return <Wrapper />;
}
